import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MarriageService} from '../../../services/marriage.service';
import {AbstractVisbosComponent} from '../../../../../core/visbos-core/components/abstract-visbos.component';
import {SessionActions} from '../../../../../shared/actions';
import {ActivatedRoute} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {RfidService} from '../../../../../identity/services/rfid.service';
import {ApolloQueryObservable} from 'apollo-angular';
import {ResolveAssetTreeByEPCsQuery, RetrieveEPCsByReaderQuery} from '../../../../../shared/graphql/graphql.types';
import * as _ from 'lodash';

@Component({
  selector: 'vb-scan-items-page',
  templateUrl: './scan-items-page.component.html',
  styleUrls: ['./scan-items-page.component.css']
})
export class ScanItemsPageComponent extends AbstractVisbosComponent implements OnInit {

  objectKeys = Object.keys;

  private readerQuery$: ApolloQueryObservable<RetrieveEPCsByReaderQuery>;
  private resolverQuery$: ApolloQueryObservable<ResolveAssetTreeByEPCsQuery>;

  lastItem;
  lastEpc = '';

  epcs: string[] = [];

  errorText;

  infoNewArticleText;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private route: ActivatedRoute, private fb: FormBuilder,
              private rfidService: RfidService, public marriageService: MarriageService) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  readRFID() {
    this.sessionActions.initAsyncAction();
    if (!this.readerQuery$) {
      this.readerQuery$ = this.rfidService.retrieveEPCsFromReader({readerCuid: this.rfidService.getReaderForMarriage()}, 'network-only');
      this.addComponentData(this.readerQuery$);
      this.addSubscription(this.readerQuery$.subscribe(res => this.handleEpcRequestResultSuccess(res), err => this.handleEpcRequestResultError(err)));
    } else {
      this.readerQuery$.refetch()
        .then(res => this.handleEpcRequestResultSuccess(res), err => this.handleEpcRequestResultError(err));
    }
  }

  private handleEpcRequestResultSuccess(res) {
    this.resolveEPCs(res.data.epcsByReader);
  }

  private handleEpcRequestResultError(err) {
    this.sessionActions.finishAsyncAction();
    this.sessionActions.throwError(err, 'Fehler beim Abrufen der RFID-Daten!', 'RFID-Lesevorgang');
  }

  resolveEPCs(epcs: string[]) {
    if (!epcs || !epcs.length) {
      this.errorText = "Es wurden kein RFID-Tags im Lesefeld erkannt!";
      this.sessionActions.finishAsyncAction();
      return;
    }

    // Merge all EPCs into a unique global list
    this.epcs = _.uniq(_.concat(this.epcs, epcs));

    // Allways resolve the global EPC list to support incremental reads
    this.resolverQuery$ = this.rfidService.resolveAssetTreeFromEPCs({epcs: this.epcs}, 'network-only');
    this.addComponentData(this.resolverQuery$);
    this.addSubscription(this.resolverQuery$.subscribe(res => {
      if (!res.loading) {
        this.sessionActions.finishAsyncAction();
      }
      this.processResolveResult(res.data);
    }));
  }

  getChildrenAssets() {
    return this.marriageService.getChildrenAssetsList();
  }

  processResolveResult(data: ResolveAssetTreeByEPCsQuery) {

    if (!data.assetTreeByEPCs || !data.assetTreeByEPCs.length) {
      this.errorText = "Es wurde keine Gegenstand für den Code '" + this.lastEpc + "' im System gefunden!";
      this.sessionActions.finishAsyncAction();
      return;
    }

    this.errorText = null;

    this.marriageService.updateAssetTree(data.assetTreeByEPCs);
    this.marriageService.lastEpcs = [...this.marriageService.lastEpcs, ...this.epcs];

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/components/asset-marriage-wizard/scan-items-page/scan-items-page.component.ts